const AssuranceRow = () => {
  const assurances = [
    { icon: '✓', label: '100% Natural', description: 'Pure herbal ingredients' },
    { icon: '⚗', label: 'Lab Tested', description: 'Quality assured' },
    { icon: '◇', label: 'Sugar Free', description: 'Healthy formulations' },
    { icon: '◉', label: 'Clinically Inspired', description: 'Science-backed' }
  ];

  return (
    <div className="border-t border-stone-200 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {assurances.map((item, index) => (
            <div key={index} className="text-center space-y-2">
              <div className="text-2xl text-emerald-700 font-light">
                {item.icon}
              </div>
              <div className="text-sm font-medium text-stone-900">
                {item.label}
              </div>
              <div className="text-xs text-stone-600">
                {item.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssuranceRow;
